export const featureItems = [
  {
    id: 1,
    icon: 'ri-movie-2-line',
    title: '海量影视资源',
    description: '覆盖电影、电视剧、综艺、动漫等全品类，超10万小时正版高清内容，每日不间断更新，随时随地畅享观影体验。',
  },
  {
    id: 2,
    icon: 'ri-speed-up-line',
    title: '极速高清播放',
    description: '自研播放引擎支持4K超清画质，智能CDN加速确保流畅不卡顿，自适应带宽优化，低网络环境也能稳定播放。',
  },
  {
    id: 3,
    icon: 'ri-smartphone-line',
    title: '多端无缝同步',
    description: '支持手机、平板、电脑、智能电视全终端覆盖，观影记录与收藏实时同步，一处观看，处处续播。',
  },
  {
    id: 4,
    icon: 'ri-shield-check-line',
    title: '纯净安全体验',
    description: '无广告干扰、无弹窗骚扰，严格的内容审核与版权保护机制，为您提供健康安心的在线观影环境。',
  },
];

export const rankingItems = [
  { rank: 1, title: '狂飙', category: '电视剧', heat: '9.8', trend: 'up', tag: '年度剧王' },
  { rank: 2, title: '流浪地球2', category: '电影', heat: '9.6', trend: 'up', tag: '科幻巨制' },
  { rank: 3, title: '奔跑吧第十季', category: '综艺', heat: '9.4', trend: 'up', tag: '热门综艺' },
  { rank: 4, title: '三体', category: '电视剧', heat: '9.3', trend: 'stable', tag: '热播中' },
  { rank: 5, title: '满江红', category: '电影', heat: '9.1', trend: 'down', tag: '口碑佳片' },
  { rank: 6, title: '乘风破浪2026', category: '综艺', heat: '9.0', trend: 'up', tag: '新一季' },
];

export const contactInfo = {
  email: 'contact@91video.com',
  wechat: '91video_official',
  qq: '4008123123',
  description: '欢迎影视制作方、内容创作者与我们联系合作。我们提供多元化的内容分发渠道与精准的流量支持，共同打造优质影视生态。',
};

export const cardItems = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20historical%20drama%20film%20scene%20with%20traditional%20costumes%20and%20dramatic%20lighting%2C%20cinematic%20composition%2C%20warm%20golden%20tones%2C%20movie%20poster%20style%2C%20professional%20film%20photography%2C%20rich%20textures%2C%20clean%20background&width=800&height=500&seq=card-movie-001&orientation=landscape',
    tag: '最新上映',
    title: '长安三万里：盛唐风华再现银幕',
    desc: '以动画史诗重构大唐气象，李白与高适的千古友情令人动容。',
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20urban%20drama%20series%20promotional%20still%20with%20city%20skyline%20background%2C%20warm%20evening%20lighting%2C%20professional%20actors%20in%20contemporary%20fashion%2C%20cinematic%20color%20grading%2C%20clean%20and%20minimal%20composition&width=800&height=500&seq=card-drama-002&orientation=landscape',
    tag: '热播剧集',
    title: '繁花：沪上风云录，时代众生相',
    desc: '王家卫首部电视剧，讲述九十年代上海商海沉浮的传奇故事。',
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20stage%20performance%20with%20colorful%20lighting%20and%20dynamic%20atmosphere%2C%20entertainment%20show%20set%20design%2C%20professional%20stage%20photography%2C%20vibrant%20warm%20colors%2C%20excited%20audience%20silhouettes%2C%20clean%20studio%20background&width=800&height=500&seq=card-variety-003&orientation=landscape',
    tag: '综艺推荐',
    title: '歌手2026：顶级唱将巅峰对决',
    desc: '华语乐坛最强音集结，每一期都是一场视听盛宴。',
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20scene%20with%20mythological%20fantasy%20elements%2C%20celestial%20palace%20in%20clouds%2C%20traditional%20Chinese%20art%20style%20blended%20with%20modern%20animation%2C%20ethereal%20golden%20and%20warm%20lighting%2C%20cinematic%20quality&width=800&height=500&seq=card-anime-004&orientation=landscape',
    tag: '动漫精选',
    title: '深海：国漫美学新高度',
    desc: '粒子水墨技术打造的奇幻世界，一场关于成长与勇气的冒险。',
  },
  {
    id: 5,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20documentary%20film%20scene%20showing%20vast%20natural%20landscape%20with%20mountains%20and%20rivers%2C%20aerial%20cinematography%2C%20golden%20hour%20sunlight%2C%20pristine%20nature%2C%20professional%20wildlife%20photography%20style%2C%20serene%20and%20majestic%20atmosphere&width=800&height=500&seq=card-doc-005&orientation=landscape',
    tag: '纪录佳作',
    title: '大河之北：千里江山入画来',
    desc: '用镜头记录中国壮丽山河，每一帧都是壁纸级的视觉享受。',
  },
  {
    id: 6,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20film%20scene%20with%20bright%20and%20cheerful%20atmosphere%2C%20warm%20home%20interior%20setting%2C%20family%20gathering%20scene%2C%20festive%20decorations%2C%20golden%20warm%20lighting%2C%20cinematic%20composition%2C%20joyful%20mood&width=800&height=500&seq=card-comedy-006&orientation=landscape',
    tag: '喜剧专场',
    title: '热辣滚烫：笑中带泪的生活赞歌',
    desc: '一部关于勇气、蜕变与自我救赎的温暖喜剧。',
  },
  {
    id: 7,
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20Chinese%20science%20fiction%20film%20scene%20with%20space%20station%20interior%2C%20advanced%20technology%20displays%2C%20dramatic%20cinematic%20lighting%20with%20warm%20accents%2C%20professional%20film%20quality%2C%20clean%20futuristic%20design%2C%20epic%20scale&width=800&height=500&seq=card-scifi-007&orientation=landscape',
    tag: '科幻力作',
    title: '宇宙探索编辑部：寻找外星文明',
    desc: '荒诞浪漫的伪纪录片风格科幻喜剧，年度口碑黑马。',
  },
];

export const updateItems = [
  { id: 1, date: '07-30', time: '14:30', title: '《狐妖小红娘·竹业篇》今日全网首播', tag: '新剧上线' },
  { id: 2, date: '07-29', time: '20:00', title: '金鸡奖提名名单公布，多部热门影片入围', tag: '行业动态' },
  { id: 3, date: '07-29', time: '16:00', title: '《大江大河3》发布首支预告片，定档暑期', tag: '即将上线' },
  { id: 4, date: '07-28', time: '18:30', title: '《长安三万里》票房突破35亿，创造动画纪录', tag: '票房捷报' },
  { id: 5, date: '07-28', time: '10:00', title: '2026暑期档片单公布，超50部新片蓄势待发', tag: '片单发布' },
  { id: 6, date: '07-27', time: '15:00', title: '《歌手2026》第三期收视率破3%，再创新高', tag: '收视捷报' },
  { id: 7, date: '07-27', time: '09:00', title: '91视频VIP会员突破5000万，感恩回馈活动开启', tag: '平台动态' },
  { id: 8, date: '07-26', time: '19:00', title: '《庆余年3》正式开机，原班人马悉数回归', tag: '开机快讯' },
  { id: 9, date: '07-25', time: '12:00', title: '国家广电总局发布2026优秀网络视听作品推优名单', tag: '政策资讯' },
];

export const carouselItems = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20historical%20war%20film%20scene%20with%20ancient%20warriors%20in%20dramatic%20battle%20formation%2C%20cinematic%20wide%20shot%2C%20golden%20sunset%20lighting%2C%20epic%20scale%2C%20professional%20film%20photography%2C%20atmospheric%20dust%20and%20smoke%2C%20warm%20earthy%20tones&width=1200&height=600&seq=carousel-focus-01&orientation=landscape',
    tag: '专题聚焦',
    title: '史诗巨制：中国历史电影黄金时代',
    desc: '从《封神》到《长安三万里》，国产史诗电影正在书写新的传奇。深度解析近年现象级历史题材影片的创作密码与观众共鸣。',
    link: '#ranking',
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20television%20studio%20with%20professional%20filming%20equipment%20and%20crew%2C%20behind%20the%20scenes%20atmosphere%2C%20warm%20set%20lighting%2C%20cinematic%20documentary%20style%2C%20creative%20process%20captured%2C%20professional%20film%20production&width=1200&height=600&seq=carousel-focus-02&orientation=landscape',
    tag: '行业观察',
    title: '短剧崛起：影视内容新赛道全面爆发',
    desc: '当碎片化时代遇见精品短剧，一场内容消费革命正在发生。我们梳理了2026年短剧赛道的头部玩家与爆款逻辑。',
    link: '#updates',
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20studio%20art%20concept%20design%20with%20traditional%20ink%20painting%20style%20characters%2C%20creative%20workspace%2C%20warm%20artistic%20lighting%2C%20professional%20concept%20art%2C%20detailed%20character%20designs%20on%20display%2C%20immersive%20creative%20atmosphere&width=1200&height=600&seq=carousel-focus-03&orientation=landscape',
    tag: '深度策划',
    title: '国漫崛起：从跟跑到领跑的美学之路',
    desc: '从《大圣归来》到《深海》，中国动画电影用十年走完了别人三十年的路。独家对话幕后创作者，揭秘国漫美学体系构建。',
    link: '#media',
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20recording%20studio%20with%20elaborate%20stage%20design%2C%20professional%20lighting%20rig%2C%20empty%20audience%20seats%20before%20show%2C%20grand%20production%20scale%2C%20warm%20stage%20lighting%2C%20cinematic%20wide%20angle%20photography%2C%20professional%20broadcast%20environment&width=1200&height=600&seq=carousel-focus-04&orientation=landscape',
    tag: '综艺解码',
    title: '综艺节目进化论：从娱乐到文化表达',
    desc: '当综艺不再只是消遣，它正成为当代文化的重要载体。盘点2026年最具创新力的综艺模式与内容趋势。',
    link: '#comments',
  },
  {
    id: 5,
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20home%20theater%20living%20room%20with%20large%20screen%20display%2C%20modern%20smart%20TV%20technology%2C%20cozy%20ambient%20lighting%2C%20premium%20entertainment%20setup%2C%20warm%20interior%20design%2C%20cinematic%20photography%2C%20clean%20minimalist%20aesthetic&width=1200&height=600&seq=carousel-focus-05&orientation=landscape',
    tag: '观影指南',
    title: '家庭影院进化：2026智能观影全方案',
    desc: '从硬件选购到平台对比，从画质调校到音效布置，一站式帮你打造专属的家庭观影空间。',
    link: '#app',
  },
];

export const aboutInfo = {
  title: '关于91视频网站',
  paragraphs: [
    '91视频网站是国内领先的综合在线视频平台，致力于为广大用户提供高清、流畅、免费的电影、电视剧、综艺、动漫等全品类影视内容。自成立以来，我们始终以"让每个人都能享受优质影视"为使命，通过持续的技术创新和内容深耕，已发展成为拥有数千万日活用户的国民级视频平台。',
    '我们与国内外上百家影视制作机构建立了深度合作关系，确保内容的正版性与时效性。平台采用智能推荐算法，根据用户的观影偏好精准匹配个性化内容，同时支持多端同步播放、离线缓存、弹幕互动等便捷功能。',
    '91视频网站不仅是一个观影工具，更是一个影视爱好者的交流社区。我们通过影评、榜单、话题讨论等形式，为用户构建了一个丰富多元的影视文化生态。',
  ],
  stats: [
    { value: '5000万+', label: '注册用户' },
    { value: '10万+', label: '影视资源' },
    { value: '200+', label: '合作机构' },
    { value: '99.9%', label: '服务可用率' },
  ],
};

export const mediaItems = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20film%20scene%20with%20traditional%20architecture%20and%20costumes%2C%20cinematic%20lighting%2C%20warm%20golden%20hour%20photography%2C%20professional%20film%20still%2C%20rich%20textures%2C%20clean%20composition%2C%20elegant%20and%20refined&width=800&height=450&seq=media-preview-01&orientation=landscape',
    title: '古装巨制·盛世风华',
    duration: '45:30',
    views: '1280万',
    tag: '电视剧',
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=Action%20thriller%20film%20scene%20with%20urban%20night%20setting%2C%20dramatic%20car%20chase%2C%20cinematic%20lighting%20with%20warm%20neon%20accents%2C%20professional%20film%20photography%2C%20dynamic%20composition%2C%20atmospheric%20and%20tense&width=800&height=450&seq=media-preview-02&orientation=landscape',
    title: '都市悬疑·暗夜追踪',
    duration: '38:15',
    views: '956万',
    tag: '电影',
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20talk%20show%20studio%20with%20celebrities%20on%20stage%2C%20professional%20broadcast%20lighting%2C%20colorful%20and%20vibrant%20atmosphere%2C%20entertainment%20show%20set%20design%2C%20warm%20stage%20lighting%2C%20professional%20photography&width=800&height=450&seq=media-preview-03&orientation=landscape',
    title: '综艺盛典·星光之夜',
    duration: '90:00',
    views: '2350万',
    tag: '综艺',
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20scene%20with%20fantasy%20landscape%20and%20mythological%20creatures%2C%20traditional%20art%20style%2C%20ethereal%20golden%20lighting%2C%20professional%20animation%20quality%2C%20rich%20colors%2C%20epic%20scale%2C%20whimsical%20atmosphere&width=800&height=450&seq=media-preview-04&orientation=landscape',
    title: '国漫神作·山海奇谭',
    duration: '22:10',
    views: '678万',
    tag: '动漫',
  },
  {
    id: 5,
    image: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20film%20scene%20with%20rare%20wildlife%20in%20natural%20habitat%2C%20aerial%20landscape%20cinematography%2C%20golden%20hour%20sunlight%2C%20professional%20wildlife%20photography%2C%20pristine%20environment%2C%20cinematic%20quality%2C%20serene%20mood&width=800&height=450&seq=media-preview-05&orientation=landscape',
    title: '自然纪录·秘境之旅',
    duration: '52:00',
    views: '412万',
    tag: '纪录片',
  },
];

export const commentItems = [
  {
    id: 1,
    avatar: 'R',
    name: '影迷小张',
    time: '2小时前',
    content: '91视频的片库真的太全了！最近在补一些经典老片，找了几个平台都没有，这里居然都有高清修复版，画质太惊喜了。',
    likes: 326,
  },
  {
    id: 2,
    avatar: 'M',
    name: '追剧达人',
    time: '5小时前',
    content: '每天通勤路上就用91视频看剧，流畅度真的没话说。地铁里信号不好自动降画质也不卡，到家秒切4K，这体验绝了。',
    likes: 218,
  },
  {
    id: 3,
    avatar: 'L',
    name: '综艺迷阿琳',
    time: '8小时前',
    content: '综艺更新速度全网最快！周六晚上播的节目，周日早上就能看了，不用再等好几天。弹幕氛围也很好，看综艺的快乐加倍。',
    likes: 189,
  },
  {
    id: 4,
    avatar: 'W',
    name: '纪录片控老王',
    time: '12小时前',
    content: '纪录片区做得越来越好，BBC、Discovery的片子都有正版引进。字幕翻译质量高，还有导演解说版，纪录片爱好者的天堂。',
    likes: 145,
  },
  {
    id: 5,
    avatar: 'C',
    name: '带娃看片的陈爸',
    time: '1天前',
    content: '儿童模式太贴心了，可以设置观看时长和内容分级，不用担心孩子看到不适合的内容。还有很多优质国产动画，推荐！',
    likes: 278,
  },
];

export const indexItems = [
  {
    id: 1,
    icon: 'ri-fire-line',
    title: '本周热播',
    count: '128部',
    desc: '全网实时热度排行，发现大家都在看的爆款内容',
    link: '#ranking',
  },
  {
    id: 2,
    icon: 'ri-movie-line',
    title: '电影专区',
    count: '5600+',
    desc: '院线大片、经典佳片、小众文艺，好电影都在这里',
    link: '#cards',
  },
  {
    id: 3,
    icon: 'ri-tv-line',
    title: '电视剧场',
    count: '3200+',
    desc: '国产剧、韩剧、美剧、日剧，热门剧集同步更新',
    link: '#cards',
  },
  {
    id: 4,
    icon: 'ri-emotion-laugh-line',
    title: '综艺娱乐',
    count: '1800+',
    desc: '搞笑、竞技、旅行、音乐，总有一档综艺让你上头',
    link: '#media',
  },
  {
    id: 5,
    icon: 'ri-robot-line',
    title: '动漫世界',
    count: '4500+',
    desc: '热血、治愈、科幻、奇幻，二次元的精彩永不打烊',
    link: '#media',
  },
  {
    id: 6,
    icon: 'ri-film-line',
    title: '纪录片库',
    count: '2100+',
    desc: '自然、历史、科技、美食，用镜头探索世界的精彩',
    link: '#carousel',
  },
  {
    id: 7,
    icon: 'ri-star-line',
    title: '高分推荐',
    count: '860部',
    desc: '豆瓣8分以上精选，品质保证，每一部都值得看',
    link: '#faq',
  },
  {
    id: 8,
    icon: 'ri-time-line',
    title: '最新上线',
    count: '每日更新',
    desc: '第一时间追新剧、看新片，不错过任何精彩内容',
    link: '#updates',
  },
];

export const appInfo = {
  title: '随时随地，畅享精彩影视',
  subtitle: '下载91视频APP，高清观影体验尽在掌握',
  features: [
    '离线缓存，无网络也能看',
    '智能续播，多设备无缝切换',
    '个性化推荐，越看越懂你',
    '弹幕互动，和千万网友一起看',
  ],
  qrImage: 'https://readdy.ai/api/search-image?query=Clean%20modern%20QR%20code%20design%20with%20minimalist%20styling%2C%20dark%20code%20on%20warm%20cream%20background%2C%20professional%20app%20download%20graphic%2C%20clean%20composition%2C%20no%20text%2C%20simple%20geometric%20pattern&width=400&height=400&seq=app-qr-download&orientation=squarish',
};

export const topicItems = [
  { id: 1, name: '国产剧崛起', count: '326万讨论', hot: true },
  { id: 2, name: '2026暑期档', count: '285万讨论', hot: true },
  { id: 3, name: '国漫封神榜', count: '198万讨论', hot: true },
  { id: 4, name: '悬疑剧天花板', count: '167万讨论', hot: false },
  { id: 5, name: '科幻电影元年', count: '152万讨论', hot: true },
  { id: 6, name: '古装剧美学', count: '139万讨论', hot: false },
  { id: 7, name: '综艺名场面', count: '121万讨论', hot: true },
  { id: 8, name: '纪录片推荐', count: '98万讨论', hot: false },
  { id: 9, name: '经典电影重映', count: '87万讨论', hot: false },
];

export const faqItems = [
  {
    id: 1,
    q: '91视频网站是否需要付费观看？',
    a: '91视频网站绝大多数内容完全免费观看，无需任何付费。我们提供少量会员专属内容供VIP用户享受，但免费内容已经覆盖了海量的电影、电视剧、综艺和动漫资源，足以满足日常观影需求。',
  },
  {
    id: 2,
    q: '91视频支持哪些设备观看？',
    a: '91视频全面支持手机（iOS/Android）、平板电脑、PC网页端以及智能电视和投影仪等多种设备。您可以在不同设备上登录同一账号，观影记录和收藏夹会自动同步，实现无缝续播。',
  },
  {
    id: 3,
    q: '视频加载慢或卡顿怎么办？',
    a: '您可以尝试以下方法：1）切换视频清晰度，选择适合当前网络带宽的画质；2）检查网络连接，建议使用WiFi观看高清内容；3）清理浏览器缓存后重试；4）更新APP到最新版本。我们采用智能CDN加速技术，通常能保证流畅播放。',
  },
  {
    id: 4,
    q: '91视频的内容多久更新一次？',
    a: '我们的内容保持每日更新。热门电视剧通常在上线后24小时内同步更新，电影在上映窗口期结束后尽快上线，综艺节目一般在播出后的次日即可观看。您可以在「最新动态」栏目查看每日更新快讯。',
  },
];